import { CUR_TQF2_SET_SEARCH_VALUES } from '../actionTypes'

// const initialState = {
//   developmentYear: '',
//   educationLevel: '',
//   campus: '',
//   faculty: '',
//   department: '',
//   major: '',
//   curriculum: '',
//   curriculumSearch: '',
//   curriculumStatus: '',
//   currentPage: 1,
//   pageSize: 5,
// }

export default function curriculumReducer(state = null, action) {
  switch (action.type) {
    case CUR_TQF2_SET_SEARCH_VALUES:
      return action.payload
    default:
      return state
  }
}
